import React, { useContext, useEffect } from 'react'
import {
  Routes,
  Route,
  useLocation
} from 'react-router-dom';
import { AppContext, ServicesContext } from './contexts';
import { useService, useTranslation } from './hooks';
import Header from './components/header';
import Book from './views/book';
import Login from './views/login';
import Manage from './views/manage';
import OrderDetails from './views/orderDetails';
import TaskDetails from './views/taskDetails';
import TaskReview from './views/taskReview';
import Message from './views/message';
import Footer from './components/footer';
import WorkOrderViewHeader from './components/workOrderViewHeader';
const Layout = () => {
  const { branding: { logo, primaryColor }, isWorkOrderView } = useContext(AppContext);
  const services = useService();
  const { i18n } = useTranslation();
  // Work order and task screens show the logo as a full-width banner
  const { pathname } = useLocation();
  const isBannerView = /^\/(order_details|task_details\/|task_review\/)/.test(pathname);
  const isLoginPage = pathname === '/';

  const appStyles = primaryColor ? `
    --primary: ${primaryColor};
    --button-primary: ${primaryColor};
  ` : '';

  useEffect(() => {
    document.documentElement.style.cssText = appStyles;
  }, [appStyles])

  // Start each page at the top instead of keeping the previous page's scroll position
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname])

  return (
    <div className="app">
      {isWorkOrderView && isBannerView ? <WorkOrderViewHeader logo={logo} alt={i18n('cp_title')} /> : <Header logo={logo} alt={i18n('cp_title')} />}
      <main role="main" className='main'>
        <ServicesContext.Provider value={{...services}}>
          <Routes>
            <Route path="book" element={<Book />} />
            <Route path="manage" element={<Manage />} />
            <Route path="order_details" element={<OrderDetails />} />
            <Route path="task_details/:taskId" element={<TaskDetails />} />
            <Route path="task_review/:taskId" element={<TaskReview />} />
            <Route path="message" element={<Message />} />
            <Route path="/" element={<Login />} />
            <Route path="*" element={<Message />} />
          </Routes>
        </ServicesContext.Provider>
      </main>
      {!isLoginPage && <Footer />}
    </div>
  )
}

export default Layout;
